<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-md">
      <div class="modal-content">

        <!-- Popup header -->
        <v-toolbar color="elevation-0">
          <v-toolbar-title>
           <h3 id="myModalLabel">
           {{title}}
          </h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon data-dismiss="modal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Popup content -->
        <v-container container--fluid>
          <v-layout wrap>
            <v-flex xs12 md12>
              <v-card v-for="post in posts" :key="post.oembed">
                <div v-html="post.oembed"></div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analysisAPI from '../ContentAnalysis/contentAnalysisAPI'
export default {
  name: 'InfluencerPostModal',
  props: [
    'modalId',
    'title',
    'shortCodes'
  ],
  data() {
    return {
      posts: []
    }
  },
  watch: {
    shortCodes(newValue) {
      this.shortCodes = newValue
      this.posts = []
      this.retrivePost()
    }
  },
  methods: {
    retrivePost() {
      this.shortCodes.forEach(async (code) => {
        let oembed = await analysisAPI.oembed(code)
        this.posts.push(oembed)
        setTimeout(() => {
          window.instgrm.Embeds.process()
        }, 100)
      })
    }
  }
}
</script>

<style>
.filter {
  padding: 5px;
  width: 180px;
  border: 1px solid gray;
  border-radius: 6px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// InfluencerPostsModal.vue?8e3ad05a